import { transformConstants } from '../helpers';

const inventoryTransferConstants = transformConstants(['MOKAPOS_INVENTORY_TRANSFER_CREATE']);

export { inventoryTransferConstants };
